import React from "react";
import { Box, Chip, FormControl, MenuItem, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setUserGroup } from "../../../redux/slices/filtersSlice";

const USER_GROUP_OPTIONS = [
  { value: "all", label: "All" },
  { value: "amgen", label: "Amgen" },
  { value: "pace", label: "PACE" },
];

const getUserGroupLabel = (value) =>
  USER_GROUP_OPTIONS.find((option) => option.value === value)?.label;

const UserGroupFilter = () => {
  const dispatch = useDispatch();
  const { userGroup } = useSelector((state) => state.filters);

  const handleChange = (event) => {
    dispatch(setUserGroup(event.target.value));
  };

  return (
    <Box display="flex" alignItems="center" sx={{ minWidth: 0, gap: "9px" }}>
      <Chip
        label={getUserGroupLabel(userGroup)}
        variant="outlined"
        sx={{
          fontSize: "14px",
          height: "32px",
          borderRadius: "8px",
          borderColor: "#ffff",
          background: "#333",
          color: "#fff",
        }}
      />

      <FormControl sx={{ minWidth: 130, flexShrink: 0 }} size="small">
        <Select
          value={userGroup}
          onChange={handleChange}
          renderValue={() => "User Group"}
          sx={{ borderRadius: "10px", height: "32px", fontSize: "14px" }}
        >
          {USER_GROUP_OPTIONS.map(({ value, label }) => (
            <MenuItem key={value} value={value} sx={{ fontSize: "14px" }}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default UserGroupFilter;
